/* Endora — Terim ipucu
 *
 * Sayfa metnindeki cilt bakim terimlerini (niasinamid, seramid, pantenol...)
 * sozlukten tanir ve uzerine gelindiginde kisa bir aciklama kutusu gosterir.
 *
 * KAYNAK: assets/sozluk-ipucu.json  (sozluk-data.json'in kucultulmus indeksi).
 *   ELLE DUZENLEMEYIN: araclar/sozluk-ipucu-uret.py ile uretilir. Sitenin
 *   kullandigi kisaltmalari (AHA, C vitamini, B5, Cica...) dogru sozluk
 *   maddesine baglayan EK_YUZEY tablosu da o dosyadadir.
 *
 * TASARIM KARARLARI (degistirmeden once okuyun):
 *  - Veri, ilk kullanici hareketine / bosta kalma anina kadar CEKILMEZ. PDP'nin
 *    ilk boyanmasini yavaslatmamasi icin kritik.
 *  - Yalnizca ALLOW listesindeki kaplarin METIN DUGUMLERI taranir; <a>, <button>,
 *    baslik ve form ogeleri atlanir. Boylece mevcut baglantilar bozulmaz.
 *  - Her terim her kapta EN FAZLA BIR KEZ isaretlenir; kap basina tavan 24.
 *    INCI listesi gibi uzun metinler alt cizgi denizine donmesin diye.
 *  - Isaretlenen oge <button> degil <span role="button" tabindex="0">: form
 *    icinde kalan alanlarda buton, formu submit edebiliyor.
 *  - Turkce harfler JS'te \w disinda kaldigi icin \b kullanilamaz; kelime siniri
 *    acik harf sinifiyla kurulur. Lookbehind YOK (eski Safari), onun yerine
 *    onek yakalama grubu kullanilir.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script) return;

  var SRC = script.getAttribute('data-src');
  var SOZLUK_URL = script.getAttribute('data-sozluk') || '';
  if (!SRC) return;

  var ALLOW = [
    '.ingl__body',          // one cikan icerikler
    '.pdp-info__sub',       // urun alt basligi ("AHA & C Vitamini Aydinlatici Krem")
    '.pdp-tabs__panel',     // faydalar / ne icin / cilt tipi
    '.acc__body',           // acilir kapanir blok govdesi
    '.acc__inci',           // INCI listesi
    '.acc__steps',          // kullanim adimlari
    '.pdp-acc__body',       // eski surum sinifi (yedek)
    '.pdp-info__lead',      // urun girisi
    '.pdp-story__text',     // urun hikayesi
    '.ingc',                // icerik kartlari
    '.article__body',       // blog yazisi
    '.page__rte'            // sade sayfalar
  ].join(',');

  var ATLA = /^(A|BUTTON|SCRIPT|STYLE|NOSCRIPT|SELECT|TEXTAREA|INPUT|LABEL|H1|H2|CODE|SVG)$/;
  var HARF = '0-9A-Za-z\\u00C0-\\u024F\\u011E\\u011F\\u0130\\u0131\\u015E\\u015F';
  var KAP_TAVAN = 24;

  var veri = null, RE = null, esle = null, kuruldu = false, baloncuk = null, acikOge = null, zaman = 0;

  /* ---------- veriyi bosta cek ---------- */

  function cek() {
    if (veri !== null) return;
    veri = 'yukleniyor';
    fetch(SRC, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
      .then(function (d) { veri = d; hazirla(); tara(); })
      .catch(function () { veri = 'hata'; });
  }

  function bosta() {
    if (window.requestIdleCallback) requestIdleCallback(cek, { timeout: 2600 });
    else setTimeout(cek, 1400);
  }

  /* ---------- eslesme tablosu ---------- */

  function kacir(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function hazirla() {
    esle = Object.create(null);
    var formlar = [];
    veri.terms.forEach(function (t) {
      t.f.forEach(function (f) {
        esle[f.toLowerCase()] = t;
        formlar.push(f);
      });
    });
    // Uzun form once: "Hidrolize hiyaluronik asit", "Hiyaluronik asit"i yutmasin.
    formlar.sort(function (a, b) { return b.length - a.length; });
    RE = new RegExp(
      '(^|[^' + HARF + '])(' + formlar.map(kacir).join('|') + ')(?![' + HARF + '])',
      'gi'
    );
  }

  /* ---------- metni isaretle ---------- */

  function tara(kok) {
    if (!RE) return;
    var kaplar = (kok || document).querySelectorAll(ALLOW);
    for (var i = 0; i < kaplar.length; i++) isaretle(kaplar[i]);
  }

  function isaretle(kap) {
    if (kap.hasAttribute('data-terim-tarandi')) return;
    kap.setAttribute('data-terim-tarandi', '');

    var yurutec = document.createTreeWalker(kap, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.length < 4) return NodeFilter.FILTER_REJECT;
        for (var p = n.parentNode; p && p !== kap; p = p.parentNode) {
          if (p.nodeType !== 1) continue;
          if (ATLA.test(p.nodeName) || p.hasAttribute('data-terim')) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var dugumler = [], n;
    while ((n = yurutec.nextNode())) dugumler.push(n);

    var gorulen = Object.create(null), sayac = 0;

    for (var i = 0; i < dugumler.length && sayac < KAP_TAVAN; i++) {
      var metin = dugumler[i].nodeValue, parcalar = null, son = 0, m;
      RE.lastIndex = 0;
      while ((m = RE.exec(metin)) !== null) {
        if (sayac >= KAP_TAVAN) break;
        var anahtar = m[2].toLowerCase();
        var terim = esle[anahtar];
        if (!terim || gorulen[terim.a]) continue;
        gorulen[terim.a] = 1;
        sayac++;

        parcalar = parcalar || document.createDocumentFragment();
        var bas = m.index + m[1].length;
        if (bas > son) parcalar.appendChild(document.createTextNode(metin.slice(son, bas)));

        var oge = document.createElement('span');
        oge.className = 'terim';
        // Ana ad degil ESLESEN YUZEY FORMU yazilir: "Cilt Bariyeri (Lipid Bariyer)"
        // gibi adlarda ana ad esle tablosunda anahtar degildir.
        oge.setAttribute('data-terim', anahtar);
        oge.setAttribute('role', 'button');
        oge.setAttribute('tabindex', '0');
        oge.setAttribute('aria-label', terim.a + ' — açıklamayı göster');
        oge.textContent = m[2];
        parcalar.appendChild(oge);

        son = bas + m[2].length;
      }
      if (parcalar) {
        if (son < metin.length) parcalar.appendChild(document.createTextNode(metin.slice(son)));
        dugumler[i].parentNode.replaceChild(parcalar, dugumler[i]);
      }
    }
  }

  /* ---------- baloncuk ---------- */

  function kacirHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function kur() {
    if (kuruldu) return;
    kuruldu = true;
    baloncuk = document.createElement('div');
    baloncuk.className = 'terim-kutu';
    baloncuk.setAttribute('role', 'tooltip');
    baloncuk.id = 'terim-kutu';
    baloncuk.hidden = true;
    document.body.appendChild(baloncuk);
  }

  function ac(oge) {
    var t = esle && esle[oge.getAttribute('data-terim') || ''];
    if (!t) return;
    kur();

    var kat = (veri.cats && veri.cats[t.k]) || { ad: '', c: '#EEE' };
    baloncuk.innerHTML =
      '<span class="terim-kutu__tag" style="--c:' + kacirHTML(kat.c) + '">' + kacirHTML(kat.ad) + '</span>' +
      '<span class="terim-kutu__ad">' + kacirHTML(t.a) + '</span>' +
      (t.i ? '<span class="terim-kutu__inci">' + kacirHTML(t.i) + '</span>' : '') +
      '<span class="terim-kutu__ozet">' + kacirHTML(t.o) + '</span>' +
      (SOZLUK_URL
        ? '<a class="terim-kutu__link" href="' + kacirHTML(SOZLUK_URL) + '?terim=' + encodeURIComponent(t.a) + '">Sözlükte aç <i aria-hidden="true">→</i></a>'
        : '');

    baloncuk.hidden = false;
    baloncuk.style.visibility = 'hidden';
    baloncuk.classList.remove('is-on', 'is-alt');
    yerlestir(oge);
    baloncuk.style.visibility = '';
    requestAnimationFrame(function () { baloncuk.classList.add('is-on'); });

    if (acikOge && acikOge !== oge) acikOge.removeAttribute('aria-describedby');
    acikOge = oge;
    oge.setAttribute('aria-describedby', 'terim-kutu');
    oge.classList.add('is-on');
  }

  function yerlestir(oge) {
    var r = oge.getBoundingClientRect();
    var g = baloncuk.getBoundingClientRect();
    var pay = 12;
    var sol = r.left + r.width / 2 - g.width / 2;
    sol = Math.max(pay, Math.min(sol, window.innerWidth - g.width - pay));

    var ust = r.top - g.height - 10;
    if (ust < pay) { ust = r.bottom + 10; baloncuk.classList.add('is-alt'); }

    baloncuk.style.left = Math.round(sol) + 'px';
    baloncuk.style.top = Math.round(ust) + 'px';
    // ok, tetikleyen kelimenin ortasina hizalanir
    baloncuk.style.setProperty('--ok', Math.round(r.left + r.width / 2 - sol) + 'px');
  }

  function kapat() {
    if (!baloncuk) return;
    baloncuk.classList.remove('is-on');
    if (acikOge) { acikOge.removeAttribute('aria-describedby'); acikOge.classList.remove('is-on'); }
    acikOge = null;
    clearTimeout(zaman);
    zaman = setTimeout(function () { if (!baloncuk.classList.contains('is-on')) baloncuk.hidden = true; }, 220);
  }

  /* ---------- olaylar ---------- */

  var ince = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  document.addEventListener('mouseover', function (e) {
    if (!ince) return;
    var oge = e.target.closest && e.target.closest('.terim');
    if (oge) { clearTimeout(zaman); zaman = setTimeout(function () { ac(oge); }, 90); return; }
    if (acikOge && !(e.target.closest && e.target.closest('.terim-kutu'))) {
      clearTimeout(zaman); zaman = setTimeout(kapat, 140);
    }
  });

  document.addEventListener('click', function (e) {
    var oge = e.target.closest && e.target.closest('.terim');
    if (oge) { e.preventDefault(); (acikOge === oge) ? kapat() : ac(oge); return; }
    if (acikOge && !(e.target.closest && e.target.closest('.terim-kutu'))) kapat();
  });

  document.addEventListener('focusin', function (e) {
    var oge = e.target.closest && e.target.closest('.terim');
    if (oge) ac(oge); else if (acikOge && !(e.target.closest && e.target.closest('.terim-kutu'))) kapat();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && acikOge) { var o = acikOge; kapat(); o.focus(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('terim')) {
      e.preventDefault(); (acikOge === e.target) ? kapat() : ac(e.target);
    }
  });

  window.addEventListener('scroll', function () { if (acikOge) yerlestir(acikOge); }, { passive: true });
  window.addEventListener('resize', kapat);

  // Sekme degisince yeni panelin metni de taranmali (paneller basta hidden)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pdp-tabs__tab')) setTimeout(function () { tara(); }, 30);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bosta);
  else bosta();

  document.addEventListener('shopify:section:load', function (e) {
    if (RE) tara(e.target);
  });
})();
